import React from 'react';
import styled from 'styled-components';

import { IconArrowDown, IconArrowUp } from '@/icons';

const StyledColumnHeading = styled.button`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color('#676570')};
  gap: 8px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  font-size: 12px;

  &:hover {
    opacity: 0.7;
  }
`;

export enum TableColumnsKeys {
  SUBSIDIARY = 'subsidiary-name',
  SHELF = 'shelves',
  PLAYER = 'players',
  STATUS = 'status',
  COMPANY = 'company-name',
}

export type SortBy = {
  readonly key: TableColumnsKeys;
  readonly direction: 'ASC' | 'DESC';
};

export const ColumnHeading = ({
  sortKey,
  setSortBy,
  sortBy,
  defaultSortOrder,
  children,
}: {
  readonly sortKey: SortBy['key'];
  readonly setSortBy: React.Dispatch<React.SetStateAction<SortBy>>;
  readonly sortBy: SortBy;
  readonly children: React.ReactNode;
  readonly defaultSortOrder: SortBy['direction'];
}) => (
  <StyledColumnHeading
    onClick={() =>
      setSortBy((prev) => ({
        key: sortKey,
        direction:
          // eslint-disable-next-line no-nested-ternary
          prev.key !== sortKey
            ? defaultSortOrder
            : sortBy.direction === 'ASC'
              ? 'DESC'
              : 'ASC',
      }))
    }
  >
    {children}
    {sortBy.key === sortKey && (
      <>{sortBy.direction === 'DESC' ? <IconArrowDown /> : <IconArrowUp />}</>
    )}
  </StyledColumnHeading>
);
